<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex lg12 md12 xl12 xs12>
          <v-card>
            <v-card-title primary-title>
              <h3 class="headline mb-0">Teilnehmer ({{ participantCount }})</h3>
              <v-spacer></v-spacer>
              <vue-json-to-csv
                  :csv-title="event.title"
                  :json-data="getParticipantsCsv()"
                  :labels="csvLabels"
              >
                <v-btn class="mr-2">Export</v-btn>
              </vue-json-to-csv>
              <v-btn @click="importDialog = true" class="mr-2">Import</v-btn>
              <v-btn @click="startNumberDialog = !startNumberDialog" class="mr-2">Startnummern</v-btn>
              <v-btn color="primary" :to="{name: 'participant', params: { id: 0 }}">
                <v-icon left>fal fa-plus</v-icon> Teilnehmer hinzufügen
              </v-btn>
            </v-card-title>
            <v-card-title>
              <v-select label="Kategorie" :items="categories" item-text="title" item-value="id" v-model="filterCategory">
                <template v-slot:prepend-item>
                  <v-list-tile ripple @click="filterCategory = null">
                    <v-list-tile-content>
                      <v-list-tile-title>Alle Kategorien</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
              <v-spacer></v-spacer>
              <v-text-field
                      append-icon="fal fa-search"
                      hide-details
                      label="Suche"
                      single-line
                      v-model="search"
              ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="participants"
                    :search="search"
                    :rows-per-page-items="[20]"
                    :pagination.sync="pagination"
            >
              <template v-slot:items="props">
                <td>{{ props.item.startNumber }}</td>
                <td>{{ props.item.firstname }}</td>
                <td>{{ props.item.lastname }}</td>
                <td>{{ props.item.postal }} {{ props.item.city }}</td>
                <td>{{ displayCategoryTitle(props.item.category) }}</td>
                <td>{{ props.item.registrationDate }}</td>
                <td class="text-xs-center">
                  <v-btn @click="openPaymentDialog(props.item.id)" flat icon>
                    <v-icon color="green" v-if="props.item.paymentStatus === 'complete'">fal fa-check</v-icon>
                    <v-icon color="orange" v-else-if="props.item.paymentStatus === 'waiting'">fal fa-exclamation-circle</v-icon>
                    <v-icon color="red" v-else>fal fa-times-circle</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-center">
                  <ParticipantStatus :participant="props.item" v-if="props.item.running"></ParticipantStatus>
                  <v-btn icon v-else>
                    <v-icon color="green" v-if="props.item.presenceStatus">fal fa-check</v-icon>
                    <v-icon color="red" v-else-if="props.item.canceled">fal fa-times-circle</v-icon>
                    <v-icon color="light-grey" style="opacity: 0.2" v-else>fal fa-question-circle</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-btn :to="{name: 'participant', params: { id: props.item.id }}" flat icon>
                    <v-icon>fal fa-edit</v-icon>
                  </v-btn>
                  <v-btn v-if="!props.item.running" @click="deleteParticipant(props.item)" color="red" flat icon>
                    <v-icon>fal fa-trash</v-icon>
                  </v-btn>
                  <v-btn v-if="props.item.duration !== null" @click="generateCertificatePdf(props.item)" flat icon>
                    <v-icon>fal fa-file-certificate</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
            <v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog max-width="450" v-model="paymentDialog">
      <v-card>
        <v-card-text>
          <Payment :participant="paymentParticipant"></Payment>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="paymentDialog = false" color="primary" flat>Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="800" v-model="importDialog">
      <v-card>
        <v-card-title>
          Neue Teilnehmer importieren
        </v-card-title>
        <v-card-text>
          <input type="file" id="file-upload" style="display: none;" @change="onFileChange" />
          <v-btn @click="openFileUpload()">Datei auswählen</v-btn>
          <v-data-table :headers="importedParticipantsHeader" :items="importedParticipants" :rows-per-page-items="[20]">
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-btn @click="importParticipants()">Import</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="importDialog = false; importedParticipants = []" color="warning" flat>Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="450" v-model="startNumberDialog">
      <v-card>
        <v-card-text>
          <v-text-field value="1000" label="Wie viele Startnummern sollen erstellt werden?" v-model="amountOfStartNumber"></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn @click="generateStartNumber()">Startnummern generieren</v-btn>
          <v-spacer></v-spacer>
          <vue-json-to-csv
              v-if="showCSVDownloadButton"
              :csv-title="event.title + ' Startnummern'"
              :json-data="startNumberList"
              :labels="csvStartNumberLabels"
          >
            <v-btn>CSV herunterladen</v-btn>
          </vue-json-to-csv>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ParticipantService from "../services/ParticipantService";
import Payment from "../components/Payment";
import VueJsonToCsv from 'vue-json-to-csv'
import ParticipantStatus from "../components/ParticipantStatus";
import startNumberService from "@/services/StartNumberService";
import Papa from "papaparse"

export default {
    components: {
      ParticipantStatus,
      Payment,
      VueJsonToCsv
    },
    computed: {
      event() {
        return this.$store.state.event
      },
      participants() {
        let participants = [...this.$store.state.participants]
        if (this.filterCategory !== null) {
          participants = participants.filter(participant => participant.category === this.filterCategory)
        }
        return participants.reverse()
      },
      paymentDate() {
        return this.payment.date.split('-').reverse().join('.')
      },
      participantCount() {
        return this.participants.length
      },
      paymentParticipant() {
        return this.$store.state.participants.find(item => item.id === this.participantId)
      },
      categories () {
        return this.$store.state.categories
      },
      pagination: {
        get() {
          return this.$store.getters.participantPagination
        },
        set(value) {
          this.$store.dispatch('setParticipantPagination', value)
        },
      },
      search: {
        get() {
          return this.$store.getters.participantSearch
        },
        set(value) {
          this.$store.dispatch('setParticipantSearch', value)
        }
      },
      filterCategory: {
        get() {
          return this.$store.getters.participantFilter
        },
        set(value) {
          this.$store.dispatch('setParticipantFilter', value)
        }
      }

    },
    methods: {
      deleteParticipant: function (participant) {
        this.$confirm('Soll der Teilnehmer ' + participant.firstname + ' ' + participant.lastname + ' wirklich gelöscht werden?').then(res => {
          if (res) {
            ParticipantService.delete(participant).then(() => {
              this.$store.dispatch('loadEvent', this.event.token)
            })
          }
        })
      },
      openPaymentDialog: function (id) {
        this.paymentDialog = true
        this.participantId = id
      },
      getParticipantsCsv () {
        return this.$store.state.participants.map(item => {
          let participant = Object.assign({}, item)
          participant.category = this.categories.find(category => category.id === participant.category).title
          participant.certificateLink = participant.startNumber !== null ? 'https://buchung.drussen.de/certificate/' + participant.uuid : ''
          return participant
        })
      },
      generateStartNumber () {
        startNumberService.generateStartNumber(this.event.token, this.amountOfStartNumber).then(result => {
          this.startNumberList = result.data
          this.showCSVDownloadButton = true
        })
      },
      progressPercent (participant) {
        if (participant.progress === 0) {
          return 0
        }

        const maxCheckpoints = this.categories.find(category => {
          if (category.id === participant.category) {
            return category.checkpoints.length
          }
        })

        return (participant.progress / maxCheckpoints.checkpoints.length * 100).toFixed(0)
      },
      displayCategoryTitle (id) {
        return this.categories.find(category => category.id === id).title
      },
      generateCertificatePdf: function (participant) {
          ParticipantService.createCertificate(participant.id).then(response => {
              const blob = new Blob([response.data], { type: 'application/pdf' })
              window.open(window.URL.createObjectURL(blob))
          })
      },
      openFileUpload() {
        document.getElementById('file-upload').click();
      },
      onFileChange(e) {
        const vue = this
        Papa.parse(e.target.files[0], {
          header: true,
          complete: function (results) {
            vue.importedParticipants = results.data
            vue.importedParticipants.map(item => item.category = vue.getCategoryByName(item.category)?.id)
          }
        })
      },
      getCategoryByName(name) {
        return this.categories.find(item => item.title === name)
      },
      importParticipants() {
        this.importedParticipants.forEach(participant => {
          participant.gender = participant.gender === 'm' ? 'male' : 'female'
          participant.canceled = false
          participant.eventId = this.event.id
          participant.country = 'DE'
          participant.startNumber = null
          ParticipantService.add(participant)
        })
      }
    },
    data: function () {
      return {
        importedParticipants: [],
        importedParticipantsHeader: [
          {
            text: 'Vorname',
            value: 'firstname'
          },
          {
            text: 'Nachname',
            value: 'lastname'
          },
          {
            text: 'Kategorie',
            value: 'category'
          },
          {
            text: 'Aktion',
            value: 'action'
          }
        ],
        amountOfStartNumber: 1000,
        showCSVDownloadButton: false,
        participantId: 0,
        paymentDialog: false,
        startNumberDialog: false,
        startNumberList: [],
        importDialog: false,
        headers: [
          {
            text: 'Startnummer',
            value: 'startNumber',
          },
          {
            text: 'Vorname',
            value: 'firstname'
          },
          {
            text: 'Nachname',
            value: 'lastname'
          },
          {
            text: 'Ort',
            value: 'city'
          },
          {
            text: 'Kategorie',
            value: 'category'
          },
          {
            text: 'Registrierung',
            value: 'registrationDateRaw'
          },
          {
            text: 'Zahlstatus',
            value: 'paymentStatus',
            align: 'center'
          },
          {
            text: 'Anwesend/Status',
            value: 'presenceStatus',
            align: 'center'
          },
          {
            text: '',
            value: ''
          },
        ],
        csvLabels: {
          id: {title: 'ID'},
          startNumber: {title: 'Startnummer'},
          firstname: {title: 'Vorname'},
          lastname: {title: 'Nachname'},
          email: {title: 'E-Mail'},
          street: {title: 'Straße'},
          postal: {title: 'Postleitzahl'},
          city: {title: 'Ort'},
          country: {title: 'Land'},
          phone: {title: 'Telefon'},
          category: {title: 'Kategorie'},
          paymentStatus:{ title: 'Zahlstatus' },
          registrationDate: { title: 'Registrierung' },
          dateOfBirth: { title: 'Geburtsdatum' },
          certificateLink: { title: 'Link zum Download der Urkunde'}
        },
        csvStartNumberLabels: {
          number: {title: 'Nummer'},
          qrCode: {title: 'QR Code Inhalt zum scannen der Startnummer'},
          certificateLink: {title: 'Link zum Download der Urkunde'}
        }
      }
    }
  }
</script>
